<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { AvatarRoot } from 'reka-ui';
    import { cn } from '../utils';

    import type { AvatarVariants } from '.';
    import { avatarVariants } from '.';

    type Props = {
        class?: HTMLAttributes['class'];
        src?: string;
        userName?: string;
        size?: AvatarVariants['size'];
        square?: boolean;
    };

    const props = withDefaults(defineProps<Props>(), {
        square: false,
    });

    const initials = computed(() => {
        const userName = props.userName;
        if (!userName) return;

        return userName
            .split(' ')
            .map((n) => n.slice(0, 1))
            .join('')
            .slice(0, 2);
    });
</script>

<template>
    <AvatarRoot
        data-slot="avatar"
        :class="cn(avatarVariants({ size, square: !!square }), props.class)"
    >
        <img
            v-if="src"
            :src="src"
            class="w-full h-full"
        />

        <span v-else-if="initials">{{ initials }}</span>

        <slot />
    </AvatarRoot>
</template>
